module.exports = __webpack_public_path__ + "static/img/qrCode.3185673c.jpg";